var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var defaultOption = {
    separator: ',',
    format: '<i>*</i>',
};
export function highlight(keyword, content, highlightOption) {
    if (highlightOption === void 0) { highlightOption = defaultOption; }
    var option = __assign(__assign({}, defaultOption), highlightOption);
    if (content) {
        var refinedKeyword = keyword.replace(/[^가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z\d\s,]/g, '');
        if (refinedKeyword) {
            var regExp = refinedKeyword
                .split(option.separator)
                .filter(Boolean)
                .map(function (s) { return "(".concat(s, ")"); })
                .join('|');
            if (regExp) {
                var _a = __read(option.format.split('*'), 2), prefix_1 = _a[0], postfix_1 = _a[1];
                return content.replace(new RegExp(regExp, 'gi'), function (match) { return "".concat(prefix_1).concat(match).concat(postfix_1); });
            }
        }
    }
    return content;
}
//# sourceMappingURL=highlight.js.map